import { render, staticRenderFns } from "./icon-arrow-custom.vue?vue&type=template&id=1a64218e&scoped=true"
import script from "./icon-arrow-custom.vue?vue&type=script&lang=js"
export * from "./icon-arrow-custom.vue?vue&type=script&lang=js"
import style0 from "./icon-arrow-custom.vue?vue&type=style&index=0&id=1a64218e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64218e",
  null
  
)

export default component.exports